import React from 'react'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

const CustomSwitchField = (props) => {
  const { label, checked, disabled, handleChange, sxLabel } = props
  const { field_key, index } = props

  const onChange = (event) => {
    handleChange(event, field_key, index)
  }

  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          disabled={disabled ? true : false}
          onChange={onChange}
        />
      }
      label={<Box sx={{ ...sxLabel }}>{label}</Box>}
    />
  )
}

export default CustomSwitchField